import axios from "axios";
import { getCookie } from "./manege_cookies";
import env from "../env";

const baseURL = env.BACKEND_BASE_URL + 'api/';
const localURL = env.FRONTEND_BASE_URL;

const http = axios.create({
  baseURL: baseURL,
  withCredentials: true,
  headers: {
    "X-CSRFToken": getCookie("csrftoken"),
  },
});

export const httpLocal = axios.create({
  baseURL: localURL,
  headers: {
    "Content-type": "application/json",
  },
});

export default http;
